/**
 * Denver venue catalog for the Create Your Own Package builder.
 *
 * Every displayed venue has a numeric planning range. Benchmark ranges are
 * explicitly labelled as Teamward estimates; venues without a responsible
 * range are kept out of this browser bundle and placed on the internal call
 * list. Contact details, source URLs, and partner terms are intentionally not
 * included here.
 *
 * Generated 2026-09-23 from VISIT DENVER venue directory.
 */

export const DENVER_VENUES = [
  {
    "id": "your-office",
    "name": "Host at your office",
    "category": "No separate venue needed",
    "area": null,
    "address": null,
    "capacity": 200,
    "isOwnSpace": true,
    "outdoor": false,
    "catering": "Bring in catering or use your on-site options",
    "includesFood": false,
    "priceLow": 0,
    "priceHigh": 0,
    "priceBasis": "per_event",
    "priceConfidence": "confirmed",
    "priceLabel": "No venue rental cost",
    "pricingMethod": "Uses the client's existing office space",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10097",
    "name": "2127 Larimer",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "2127 Larimer St.",
    "capacity": 48,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 8500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41184",
    "name": "5 Star Salt Caves Inc",
    "category": "Wellness & Retreat",
    "area": "South Broadway / Wash Park",
    "address": "722 S. Pearl St.",
    "capacity": 22,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 45,
    "priceHigh": 180,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-34861",
    "name": "A5 Steakhouse",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1600 15th St.",
    "capacity": 125,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41583",
    "name": "AC Hotel RiNo",
    "category": "Hotel & Conference",
    "area": "Downtown / LoDo / RiNo",
    "address": "3680 Brighton Blvd.",
    "capacity": 45,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 12500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10013",
    "name": "Ace Eat Serve",
    "category": "Activity & Team Building",
    "area": "Capitol Hill / Uptown",
    "address": "501 E. 17th Ave.",
    "capacity": 500,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9427",
    "name": "Adams Mystery Playhouse",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2406 N. Federal Blvd.",
    "capacity": 120,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39512",
    "name": "Adults & Crafts",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "3851 N. Steele St.",
    "capacity": 30,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41613",
    "name": "Adventure Time Bar",
    "category": "Restaurant & Private Dining",
    "area": "South Broadway / Wash Park",
    "address": "101 N. Broadway",
    "capacity": 80,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25037",
    "name": "AEG Presents - The Mission Ballroom",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "4242 Wynkoop St.",
    "capacity": 2200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 5500,
    "priceHigh": 50500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-38504",
    "name": "Ajax Downtown",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1899 16th St.",
    "capacity": 125,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-38787",
    "name": "Ambler",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1801 Wewatta St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21026",
    "name": "American Museum of Western Art - The Anschutz Collection",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "1727 Tremont Place",
    "capacity": 130,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 14000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39796",
    "name": "Apollo Hall",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1427 Larimer St.",
    "capacity": 400,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9100",
    "name": "Appaloosa Grill",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "535 16th St.",
    "capacity": 175,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-34223",
    "name": "Apple Blossom",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "822 18th St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25649",
    "name": "Archery Games Denver",
    "category": "Activity & Team Building",
    "area": "West Metro / Golden",
    "address": "5405 W. 56th Ave.",
    "capacity": 75,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8848",
    "name": "Arrowhead Golf Club",
    "category": "Parks & Outdoor",
    "area": "South Metro",
    "address": "10850 W. Sundown Trail",
    "capacity": 200,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 500,
    "priceHigh": 8000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41344",
    "name": "Ash and Agave",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "3000 E. 1st Ave.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35344",
    "name": "Ash'Kara Denver",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2005 W. 33rd Ave.",
    "capacity": 100,
    "outdoor": true,
    "catering": "In-house or approved caterers",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8793",
    "name": "Auraria Campus — Tivoli Student Union",
    "category": "Campus & Meeting Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "900 Auraria Pkwy.",
    "capacity": 700,
    "outdoor": true,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 1250,
    "priceHigh": 13500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-14084",
    "name": "Avanti F and B",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "3200 Pecos St.",
    "capacity": 500,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39418",
    "name": "Aviano - Detroit",
    "category": "Dedicated Event Space",
    "area": "Cherry Creek",
    "address": "244 Detroit St.",
    "capacity": 35,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 6500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39416",
    "name": "Aviano - St. Paul",
    "category": "Dedicated Event Space",
    "area": "Cherry Creek",
    "address": "215 St. Paul St.",
    "capacity": 40,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 6500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8385",
    "name": "Baldoria on the Water",
    "category": "Dedicated Event Space",
    "area": "West Metro / Golden",
    "address": "146 W. Van Gordon St.",
    "capacity": 300,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9506",
    "name": "Balistreri Vineyards",
    "category": "Brewery, Winery & Distillery",
    "area": "North Metro / Boulder",
    "address": "1946 E. 66th Ave.",
    "capacity": 250,
    "outdoor": true,
    "catering": "In-house or approved caterers",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39784",
    "name": "Bao Brewhouse",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "1317 14th St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-29091",
    "name": "Bar Dough",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2227 W. 32nd Ave.",
    "capacity": 90,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9345",
    "name": "Barolo Grill",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "3030 E. 6th Ave.",
    "capacity": 120,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41294",
    "name": "Beat The Bomb",
    "category": "Activity & Team Building",
    "area": "Capitol Hill / Uptown",
    "address": "3863 Steele St.",
    "capacity": 30,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21927",
    "name": "Beau's Kitchen & Tavern",
    "category": "Restaurant & Private Dining",
    "area": "West Metro / Golden",
    "address": "360 Union Blvd.",
    "capacity": 50,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-26692",
    "name": "Beckon",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2843 Larimer St.",
    "capacity": 35,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35412",
    "name": "BEZEL Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1550 Court Pl.",
    "capacity": 150,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24118",
    "name": "Bierstadt Lagerhaus",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2875 Blake St.",
    "capacity": 650,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21091",
    "name": "Bigsby's Folly Craft Winery",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "3563 Wazee St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9159",
    "name": "Bistro Vendome",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "2267 Kearney St.",
    "capacity": 120,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9115",
    "name": "Black American West Museum",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "3091 California St.",
    "capacity": 50,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 10000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19295",
    "name": "Black Shirt Brewing Co",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "3719 Walnut St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28301",
    "name": "Blair Caldwell African American Research Library",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "2401 Welton St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1250,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42619",
    "name": "Bombshells Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1400 Arapahoe St.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28942",
    "name": "Breckenridge Brewery Ale & Game House",
    "category": "Brewery, Winery & Distillery",
    "area": "South Metro",
    "address": "200 Inverness Dr. W.",
    "capacity": 180,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40695",
    "name": "Broadway 10 Bar & Chophouse",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "2345 E. 3rd Ave.",
    "capacity": 50,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39476",
    "name": "Brothers Bar & Grill",
    "category": "Restaurant & Private Dining",
    "area": "East Metro",
    "address": "8270 E. Northfield Blvd.",
    "capacity": 500,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8780",
    "name": "Buckhorn Exchange",
    "category": "Restaurant & Private Dining",
    "area": "Santa Fe Arts District",
    "address": "1000 Osage St.",
    "capacity": 150,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36774",
    "name": "BurnDown",
    "category": "Restaurant & Private Dining",
    "area": "South Broadway / Wash Park",
    "address": "476 S. Broadway",
    "capacity": 650,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8946",
    "name": "Butterfly Pavilion",
    "category": "Museum & Cultural",
    "area": "North Metro / Boulder",
    "address": "6252 W. 104th Ave.",
    "capacity": 1200,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 2750,
    "priceHigh": 26000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40946",
    "name": "Call Me Pearl",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1600 20th St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24657",
    "name": "CAVEA Theater",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "Jordan Student Success Building",
    "capacity": 96,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 15500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41636",
    "name": "Celestia Experience LLC",
    "category": "Activity & Team Building",
    "area": "Capitol Hill / Uptown",
    "address": "Saint John's Cathedral",
    "capacity": 400,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9477",
    "name": "Chambers Grant Salon in the Ellie Caulkins Opera House",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1400 Curtis St.",
    "capacity": 400,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-38790",
    "name": "Champagne Tiger",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "601 E. Colfax Ave.",
    "capacity": 249,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35444",
    "name": "Cherry Cricket Ballpark",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "2220 Blake St.",
    "capacity": 60,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 8500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35063",
    "name": "Chez Maggy",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1616 Market St.",
    "capacity": 60,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39719",
    "name": "Chicken N Pickle",
    "category": "Activity & Team Building",
    "area": "North Metro / Boulder",
    "address": "14175 Lincoln St.",
    "capacity": 1056,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8891",
    "name": "Children's Museum of Denver at Marsico Campus",
    "category": "Campus & Meeting Space",
    "area": "Highlands / LoHi",
    "address": "2121 Children's Museum Dr.",
    "capacity": 200,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 750,
    "priceHigh": 9000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9851",
    "name": "ChoLon Bistro",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1555 Blake St.",
    "capacity": 150,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41688",
    "name": "Chubby Unicorn Cantina",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "4180 Wynkoop St.",
    "capacity": 180,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37159",
    "name": "City & County of Denver, Golf Courses",
    "category": "Parks & Outdoor",
    "area": "Denver Metro",
    "address": "101 W. Colfax Ave.",
    "capacity": 150,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 500,
    "priceHigh": 8000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9680",
    "name": "City Park Pavilion",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "2001 Steele St.",
    "capacity": 350,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19630",
    "name": "Cleo Parker Robinson Dance",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "119 Park Ave. W.",
    "capacity": 300,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40736",
    "name": "CLP Jewelry",
    "category": "Activity & Team Building",
    "area": "South Broadway / Wash Park",
    "address": "1407 S. Broadway",
    "capacity": 75,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9902",
    "name": "Clyfford Still Museum",
    "category": "Museum & Cultural",
    "area": "Golden Triangle",
    "address": "1250 Bannock St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 14000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19719",
    "name": "Colorado Ballet",
    "category": "Dedicated Event Space",
    "area": "Santa Fe Arts District",
    "address": "1075 Santa Fe Dr.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41411",
    "name": "Colorado Karting Circuit",
    "category": "Activity & Team Building",
    "area": "South Metro",
    "address": "13600 Eagle Rock Rd.",
    "capacity": 100,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-22022",
    "name": "Colorado Photographic Arts Center",
    "category": "Dedicated Event Space",
    "area": "Golden Triangle",
    "address": "1200 Lincoln St.",
    "capacity": 145,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39997",
    "name": "Colorado Railbike Adventures",
    "category": "Activity & Team Building",
    "area": "North Metro / Boulder",
    "address": "4121 County Rd. 3",
    "capacity": 150,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24126",
    "name": "Colorado Railroad Museum",
    "category": "Museum & Cultural",
    "area": "West Metro / Golden",
    "address": "17155 W. 44th Ave.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 17000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-27847",
    "name": "Colorado Sake Co.",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "3559 Larimer St.",
    "capacity": 80,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9119",
    "name": "Colorado Sports Hall of Fame",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "Empower Field at Mile High",
    "capacity": 75,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 10000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8841",
    "name": "Comedy Works Downtown in Larimer Square",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1226 15th St.",
    "capacity": 324,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42046",
    "name": "Community Clay",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "3349 Blake St.",
    "capacity": 20,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 6500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9924",
    "name": "Coohills",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1400 Wewatta St.",
    "capacity": 400,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-12275",
    "name": "Cooper Lounge",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1701 Wynkoop St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-22525",
    "name": "Corinne Restaurant",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1455 California St.",
    "capacity": 44,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9740",
    "name": "Counterterrorism Education Learning Lab (CELL)",
    "category": "Museum & Cultural",
    "area": "Golden Triangle",
    "address": "99 W. 12th Ave.",
    "capacity": 45,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 10000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25016",
    "name": "Courier. market | bar | kitchen",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1750 Welton St.",
    "capacity": 115,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9243",
    "name": "Coyote Ugly Saloon",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "500 16th St.",
    "capacity": 375,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35330",
    "name": "CSU Spur",
    "category": "Campus & Meeting Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "4777 National Western Dr.",
    "capacity": 3650,
    "outdoor": true,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 30500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19846",
    "name": "Dazzle",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1080 14th St.",
    "capacity": 299,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-33485",
    "name": "Denver Art Museum",
    "category": "Museum & Cultural",
    "area": "Golden Triangle",
    "address": "100 W. 14th Ave. Pkwy.",
    "capacity": 650,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 21000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8752",
    "name": "Denver Athletic Club",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1325 Glenarm Pl.",
    "capacity": 400,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8768",
    "name": "Denver Botanic Gardens",
    "category": "Museum & Cultural",
    "area": "Cherry Creek",
    "address": "1007 York St.",
    "capacity": 300,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 17000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8808",
    "name": "Denver Center for the Performing Arts (DCPA)",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis in downtown’s Arts Complex",
    "capacity": 950,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 3750,
    "priceHigh": 33500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41648",
    "name": "Denver Charter Fishing",
    "category": "Activity & Team Building",
    "area": "South Metro",
    "address": "Cherry Creek Reservoir",
    "capacity": 13,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8966",
    "name": "Denver Chophouse & Brewery",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1735 19th St.",
    "capacity": 488,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8845",
    "name": "Denver Firefighters Museum",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "1326 Tremont Pl.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 14000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25167",
    "name": "Denver Milk Market",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1800 Wazee St.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8893",
    "name": "Denver Museum of Nature & Science",
    "category": "Museum & Cultural",
    "area": "Capitol Hill / Uptown",
    "address": "2001 Colorado Blvd.",
    "capacity": 4000,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 5000,
    "priceHigh": 47500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9018",
    "name": "Denver Pavilions",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "500 16th St.",
    "capacity": 500,
    "outdoor": true,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8778",
    "name": "Denver Public Library",
    "category": "Museum & Cultural",
    "area": "Golden Triangle",
    "address": "10 W. 14th Ave. Pkwy.",
    "capacity": 360,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 17000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-12403",
    "name": "Denver Union Station",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1701 Wynkoop St.",
    "capacity": 800,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2750,
    "priceHigh": 22000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42614",
    "name": "Denver Zen Den",
    "category": "Wellness & Retreat",
    "area": "Highlands / LoHi",
    "address": "2345 7th St.",
    "capacity": 40,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 45,
    "priceHigh": 180,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9190",
    "name": "Denver's Art District on Santa Fe",
    "category": "Dedicated Event Space",
    "area": "Santa Fe Arts District",
    "address": "525 Santa Fe Dr.",
    "capacity": 900,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 2750,
    "priceHigh": 22000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-34206",
    "name": "Dierks Bentley's Whiskey Row",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1946 Market St.",
    "capacity": 850,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41355",
    "name": "DIRT",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1435 15th St.",
    "capacity": 175,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9002",
    "name": "Downtown Aquarium",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "700 Water St.",
    "capacity": 1500,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 3500,
    "priceHigh": 31500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9469",
    "name": "duo Restaurant",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2413 W. 32nd Ave.",
    "capacity": 80,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9349",
    "name": "Earls Kitchen + Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1600 Glenarm Pl.",
    "capacity": 500,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-17979",
    "name": "Eddie Merlot's",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "10110 E. Dry Creek Rd.",
    "capacity": 80,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9855",
    "name": "EDGE Restaurant & Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1111 14th St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21146",
    "name": "El Five",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2930 Umatilla St.",
    "capacity": 225,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-29083",
    "name": "Elements",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1420 Stout St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9412",
    "name": "Ellie Caulkins Opera House",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1400 Curtis St.",
    "capacity": 2225,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 5500,
    "priceHigh": 50500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9110",
    "name": "Ellyngton's",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "321 17th St.",
    "capacity": 180,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9573",
    "name": "Elway's Downtown",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1881 Curtis St.",
    "capacity": 200,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41245",
    "name": "Ember and Stitch",
    "category": "Activity & Team Building",
    "area": "Santa Fe Arts District",
    "address": "918 W. 8th Ave.",
    "capacity": 36,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37004",
    "name": "Emerald Eye",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1403 Larimer St.",
    "capacity": 152,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-27530",
    "name": "EscapeWorks Denver Convention Center",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "1529 Champa St.",
    "capacity": 60,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-33108",
    "name": "Famille Westminster",
    "category": "Restaurant & Private Dining",
    "area": "North Metro / Boulder",
    "address": "8875 Westminster Blvd.",
    "capacity": 120,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35304",
    "name": "Federales",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2901 Larimer St.",
    "capacity": 80,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24538",
    "name": "FIRE at the ART Hotel",
    "category": "Restaurant & Private Dining",
    "area": "Golden Triangle",
    "address": "1201 Broadway St.",
    "capacity": 40,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35788",
    "name": "Flight Club Denver",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "1959 16th St.",
    "capacity": 450,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35230",
    "name": "FlyteCo Tower",
    "category": "Activity & Team Building",
    "area": "East Metro",
    "address": "3120 Uinta St.",
    "capacity": 850,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9731",
    "name": "Fogo de Chao Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1513 Wynkoop St.",
    "capacity": 400,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25412",
    "name": "fooLPRoof contemporary art — gallery",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "3240 Larimer St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1250,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35347",
    "name": "Forget Me Not",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "227 Clayton St.",
    "capacity": 130,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9094",
    "name": "Forney Museum of Transportation",
    "category": "Museum & Cultural",
    "area": "North Metro / Boulder",
    "address": "4303 Brighton Blvd.",
    "capacity": 500,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 21000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36462",
    "name": "Fortissimo Dueling Pianos",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "891 14th St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 2000,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8884",
    "name": "Four Mile Historic Park",
    "category": "Museum & Cultural",
    "area": "Cherry Creek",
    "address": "715 S. Forest St.",
    "capacity": 2500,
    "outdoor": true,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 4250,
    "priceHigh": 39000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41224",
    "name": "Frank & Roze",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "494 E. 19th Ave.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9651",
    "name": "Fritz Knoebel School of Hospitality Management",
    "category": "Campus & Meeting Space",
    "area": "Cherry Creek",
    "address": "2044 E. Evans Ave.",
    "capacity": 450,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 1250,
    "priceHigh": 13500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9414",
    "name": "Garner Galleria Theatre & Bar",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis in downtown’s Arts Complex",
    "capacity": 210,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2000,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40419",
    "name": "Gem Hats",
    "category": "Activity & Team Building",
    "area": "Highlands / LoHi",
    "address": "1955 W. 32nd Ave.",
    "capacity": 30,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-18037",
    "name": "Globe Hall Live Music & Kitchen",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "4483 Logan St.",
    "capacity": 390,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37158",
    "name": "Golden History Museum & Park",
    "category": "Museum & Cultural",
    "area": "West Metro / Golden",
    "address": "923 10th St.",
    "capacity": 250,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 17000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9137",
    "name": "Grant-Humphreys Mansion",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "770 Pennsylvania St.",
    "capacity": 200,
    "outdoor": true,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42713",
    "name": "Great Big Game Show",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "2620 Walnut St.",
    "capacity": 80,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42232",
    "name": "Grid City VR",
    "category": "Activity & Team Building",
    "area": "North Metro / Boulder",
    "address": "5700 W. 89th Ave.",
    "capacity": 130,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8862",
    "name": "Grizzly Rose",
    "category": "Performance & Nightlife",
    "area": "North Metro / Boulder",
    "address": "5450 N. Valley Hwy.",
    "capacity": 2000,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 4500,
    "priceHigh": 40500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10628",
    "name": "Guard and Grace",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1801 California St.",
    "capacity": 400,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36315",
    "name": "Hapa Sushi Grill & Sake Bar",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "3030 E. 2nd Ave.",
    "capacity": 20,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9973",
    "name": "Hapa Sushi Grill and Sake Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1514 Blake St.",
    "capacity": 50,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39606",
    "name": "Happy Camper Denver",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "3211 N. Pecos St.",
    "capacity": 500,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41275",
    "name": "HashTAG Downtown",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1125 17th St.",
    "capacity": 120,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-14223",
    "name": "Henry's Tavern",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "500 16th St.",
    "capacity": 400,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21196",
    "name": "Hickory & Ash",
    "category": "Restaurant & Private Dining",
    "area": "North Metro / Boulder",
    "address": "8001 Arista Pl.",
    "capacity": 168,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-20814",
    "name": "Historic Elitch Theatre",
    "category": "Performance & Nightlife",
    "area": "Highlands / LoHi",
    "address": "4600 W 37th Place",
    "capacity": 600,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 3000,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9366",
    "name": "History Colorado Center",
    "category": "Museum & Cultural",
    "area": "Golden Triangle",
    "address": "1200 N Broadway",
    "capacity": 2094,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 4250,
    "priceHigh": 39000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36888",
    "name": "Holey Moley",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "1201 18th St.",
    "capacity": 350,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-34226",
    "name": "Honey Elixir Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2636 Walnut St.",
    "capacity": 75,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9404",
    "name": "iFLY Denver",
    "category": "Activity & Team Building",
    "area": "South Metro",
    "address": "9230 Park Meadows Dr.",
    "capacity": 250,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24879",
    "name": "Improper City",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "3201 Walnut St.",
    "capacity": 1000,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2750,
    "priceHigh": 22000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9104",
    "name": "Infinity Theater",
    "category": "Performance & Nightlife",
    "area": "Capitol Hill / Uptown",
    "address": "2001 Colorado Blvd.",
    "capacity": 390,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25727",
    "name": "Ironworks",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "25 Larimer St.",
    "capacity": 400,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9325",
    "name": "Jax Fish House LoDo",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1539 17th St.",
    "capacity": 125,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9407",
    "name": "Jill's Restaurant in the St Julien Hotel & Spa",
    "category": "Restaurant & Private Dining",
    "area": "North Metro / Boulder",
    "address": "900 Walnut St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-26653",
    "name": "Jovanina's Broken Italian",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1520 Blake St.",
    "capacity": 250,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28573",
    "name": "Kachina Cantina",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1890 Wazee St.",
    "capacity": 45,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39721",
    "name": "Kim Robards Dance",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1755 W. 48th Ave.",
    "capacity": 400,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40318",
    "name": "La Loma",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1601 19th St.",
    "capacity": 500,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35507",
    "name": "Larimer Lounge",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "2721 Larimer St.",
    "capacity": 350,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19829",
    "name": "Laws Whiskey House",
    "category": "Brewery, Winery & Distillery",
    "area": "South Broadway / Wash Park",
    "address": "80 W. Arkansas Ave",
    "capacity": 100,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-34996",
    "name": "Left Hand RiNo Food & Eats",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "4180 Wynkoop St.",
    "capacity": 500,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-27013",
    "name": "Leven Deli Co.",
    "category": "Restaurant & Private Dining",
    "area": "Golden Triangle",
    "address": "123 W. 12th Ave.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21831",
    "name": "Linger",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2030 W. 30th Ave.",
    "capacity": 500,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-18065",
    "name": "Little India Restaurant & Bar - 6th Ave.",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "330 E. 6th Ave.",
    "capacity": 40,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36360",
    "name": "Little India Restaurant & Bar - Central Park",
    "category": "Restaurant & Private Dining",
    "area": "East Metro",
    "address": "7352 E. 29th Ave.",
    "capacity": 30,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-18069",
    "name": "Little India Restaurant & Bar - DU/Washington Park",
    "category": "Restaurant & Private Dining",
    "area": "South Broadway / Wash Park",
    "address": "2390 S. Downing St.",
    "capacity": 40,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-31345",
    "name": "Local Jones",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "249 Columbine St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9241",
    "name": "Luca",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "711 Grant St.",
    "capacity": 85,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9220",
    "name": "Lucky Strike",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "500 16th St.",
    "capacity": 1200,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9036",
    "name": "Maggiano's Little Italy",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "500 16th St.",
    "capacity": 340,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9468",
    "name": "Magnolia Ballroom",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "817 17th St.",
    "capacity": 300,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25731",
    "name": "Main Event Highlands Ranch",
    "category": "Activity & Team Building",
    "area": "South Metro",
    "address": "64 Centennial Blvd.",
    "capacity": 1000,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37001",
    "name": "Major Tom",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2845 Larimer St.",
    "capacity": 45,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40691",
    "name": "Mama Kim Malaysian Fusion",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "8745 E. Orchard Rd.",
    "capacity": 60,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9693",
    "name": "Mangia Bevi Cafe",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "6363 S. Fiddlers Green Cir.",
    "capacity": 800,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-26953",
    "name": "Marquis Theater",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "2009 Larimer St.",
    "capacity": 250,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9054",
    "name": "MCA DENVER — Museum of Contemporary Art Denver",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "1485 Delgany St.",
    "capacity": 175,
    "outdoor": true,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 14000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41417",
    "name": "McGregor Square",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1901 Wazee St.",
    "capacity": 2000,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 3500,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10028",
    "name": "McNichols Civic Center Building, Denver Arts & Venues",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "144 W. Colfax Ave.",
    "capacity": 2000,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 3500,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-32785",
    "name": "Meow Wolf Denver",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "1338 1st St.",
    "capacity": 2000,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-12648",
    "name": "Mercantile dining & provision",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1701 Wynkoop St.",
    "capacity": 125,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9648",
    "name": "Metropolitan State University of Denver - Center for Visual Art",
    "category": "Campus & Meeting Space",
    "area": "Santa Fe Arts District",
    "address": "965 Santa Fe Dr.",
    "capacity": 300,
    "outdoor": true,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 11000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9095",
    "name": "Mile High Station",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2027 W. Colfax Ave.",
    "capacity": 1200,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35350",
    "name": "Mister Oso",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "3163 Larimer St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39413",
    "name": "Mister Oso - Wash Park",
    "category": "Restaurant & Private Dining",
    "area": "South Broadway / Wash Park",
    "address": "103 S. Ogden St.",
    "capacity": 150,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8817",
    "name": "Mizel Museum",
    "category": "Museum & Cultural",
    "area": "Cherry Creek",
    "address": "400 S. Kearney St.",
    "capacity": 125,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 1250,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9237",
    "name": "Mizuna",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "225 E. 7th Ave.",
    "capacity": 65,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9681",
    "name": "Montclair Civic Building \"The Molkery\"",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "6820 E. 12th Ave.",
    "capacity": 75,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41108",
    "name": "Moodswing",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "3625 E. 48th Ave.",
    "capacity": 670,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10091",
    "name": "Mountain West Institute",
    "category": "Campus & Meeting Space",
    "area": "Golden Triangle",
    "address": "925 Lincoln St.",
    "capacity": 200,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 750,
    "priceHigh": 9000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21795",
    "name": "Moxy Bar",
    "category": "Hotel & Conference",
    "area": "Cherry Creek",
    "address": "240 Josephine St.",
    "capacity": 60,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 12500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8950",
    "name": "Museo de las Americas",
    "category": "Dedicated Event Space",
    "area": "Santa Fe Arts District",
    "address": "861 Santa Fe Dr.",
    "capacity": 250,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40397",
    "name": "Museum For Black Girls",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "500 16th St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 14000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39615",
    "name": "My Neighbor Felix",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "1801 Central St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39777",
    "name": "NADC Burger",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1441 Larimer St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25823",
    "name": "Narrative",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "222 Milwaukee St.",
    "capacity": 98,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-14166",
    "name": "Nocturne",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1330 27th St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28244",
    "name": "Nomad Taqueria & Beer Garden",
    "category": "Restaurant & Private Dining",
    "area": "West Metro / Golden",
    "address": "18485 W. Colfax Ave.",
    "capacity": 150,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-33839",
    "name": "Novel Strand Brewing Company",
    "category": "Brewery, Winery & Distillery",
    "area": "South Broadway / Wash Park",
    "address": "305 W. 1st Ave.",
    "capacity": 70,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-32526",
    "name": "Number Thirty Eight",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "3560 Chestnut Place",
    "capacity": 1200,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-33317",
    "name": "Oakwell Beer Spa Denver",
    "category": "Wellness & Retreat",
    "area": "Downtown / LoDo / RiNo",
    "address": "3004 N. Downing St.",
    "capacity": 60,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 45,
    "priceHigh": 180,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39927",
    "name": "Oakwell Beer Spa Highlands Ranch",
    "category": "Wellness & Retreat",
    "area": "South Metro",
    "address": "6660 Timberline Rd.",
    "capacity": 60,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 45,
    "priceHigh": 180,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9841",
    "name": "Ocean Prime",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1465 Larimer St.",
    "capacity": 325,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25673",
    "name": "Ocean Prime - Denver Tech Center",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "8000 Belleview Ave.",
    "capacity": 60,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40597",
    "name": "Olive & Finch Arts Complex",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1000 14th St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42693",
    "name": "Olive & Finch Golden Triangle",
    "category": "Restaurant & Private Dining",
    "area": "Golden Triangle",
    "address": "1140 N. Bannock St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40440",
    "name": "Olive & Finch Union Station",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1701 Wynkoop St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-14055",
    "name": "Ophelia's Electric Soapbox",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1215 20th St.",
    "capacity": 450,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 3000,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9539",
    "name": "Osteria Marco",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1453 Larimer St.",
    "capacity": 200,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9109",
    "name": "Palace Arms",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "321 17th St.",
    "capacity": 20,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9041",
    "name": "Panzano Restaurant",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "909 17th St.",
    "capacity": 250,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8979",
    "name": "Paramount Theatre",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1621 Glenarm Pl.",
    "capacity": 1947,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 4500,
    "priceHigh": 40500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36748",
    "name": "Parlur",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1550 Court Pl.",
    "capacity": 750,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9508",
    "name": "Peaks Lounge at Hyatt Regency CCC",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "650 15th St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41936",
    "name": "Performance Now Theatre Company",
    "category": "Performance & Nightlife",
    "area": "West Metro / Golden",
    "address": "9255 W. Alameda Ave.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2000,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-33411",
    "name": "Pindustry",
    "category": "Activity & Team Building",
    "area": "South Metro",
    "address": "7939 E. Arapahoe Rd.",
    "capacity": 2000,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8754",
    "name": "Pinnacle Club by Grand Hyatt",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1750 Welton St.",
    "capacity": 1000,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-29124",
    "name": "Pint Brothers Alehouse",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "4900 S. Syracuse St.",
    "capacity": 150,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40512",
    "name": "Point Easy Denver",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "2000 E. 28th Ave.",
    "capacity": 100,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-32840",
    "name": "Poka Lola Social Club",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1850 Wazee St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24392",
    "name": "Prospect's Urban Kitchen & Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1701 California St.",
    "capacity": 250,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9944",
    "name": "Punch Bowl Social — Food & Drink",
    "category": "Activity & Team Building",
    "area": "South Broadway / Wash Park",
    "address": "65 Broadway",
    "capacity": 1000,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36691",
    "name": "Puttshack",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "2813 Blake St.",
    "capacity": 600,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19602",
    "name": "range, new american west",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "918 17th St.",
    "capacity": 75,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-14347",
    "name": "Ratio Beerworks",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "2920 Larimer St.",
    "capacity": 200,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9612",
    "name": "RedLine Contemporary Art Center",
    "category": "Museum & Cultural",
    "area": "Downtown / LoDo / RiNo",
    "address": "2350 Arapahoe St.",
    "capacity": 485,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 21000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9441",
    "name": "ReelWorks and Tracks Denver",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1399 35th St.",
    "capacity": 2500,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 5500,
    "priceHigh": 50500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42234",
    "name": "Renegade Brewing",
    "category": "Brewery, Winery & Distillery",
    "area": "Santa Fe Arts District",
    "address": "925 W. 9th Ave.",
    "capacity": 120,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-38292",
    "name": "Restaurant Olivia",
    "category": "Restaurant & Private Dining",
    "area": "South Broadway / Wash Park",
    "address": "290 S. Downing St.",
    "capacity": 65,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35078",
    "name": "Reynard Social Spaces",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1616 Market St.",
    "capacity": 200,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-17995",
    "name": "Rhein Haus Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1415 Market St.",
    "capacity": 600,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9056",
    "name": "Rio on Wazee",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1745 Wazee St.",
    "capacity": 225,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9249",
    "name": "Rioja",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1431 Larimer St.",
    "capacity": 125,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9821",
    "name": "RISE Comedy",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1260 22nd St.",
    "capacity": 99,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 15500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19844",
    "name": "Rockmount Ranch Wear Mfg. Co.",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1626 Wazee St.",
    "capacity": 75,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 8500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9195",
    "name": "Rodizio Grill, The Brazilian Steakhouse",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1801 Wynkoop St.",
    "capacity": 90,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39506",
    "name": "ROK SPAS",
    "category": "Wellness & Retreat",
    "area": "Downtown / LoDo / RiNo",
    "address": "2025 17th St.",
    "capacity": 35,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 45,
    "priceHigh": 180,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37254",
    "name": "Rooftop1630 & Strive Denver",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1630 Welton St.",
    "capacity": 425,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9703",
    "name": "Root Down",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "1600 W. 33rd Ave.",
    "capacity": 250,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9107",
    "name": "Root25 Taphouse & Kitchen",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "7800 E. Tufts Ave.",
    "capacity": 100,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41589",
    "name": "Rougarou",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2844 Welton St.",
    "capacity": 174,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10104",
    "name": "Ruth's Chris Steak House",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "707 15th St.",
    "capacity": 450,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25626",
    "name": "Safta Restaurant",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "3330 Brighton Blvd.",
    "capacity": 130,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39794",
    "name": "Salt Water Social",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "201 Columbine St.",
    "capacity": 275,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21814",
    "name": "Saltgrass Steak House Parker",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "19310 Cottonwood Dr.",
    "capacity": 50,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41846",
    "name": "Savina's Downtown",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1801 Broadway",
    "capacity": 35,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9193",
    "name": "Seawell Ballroom",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis atop the Helen G Bonfils Theatre Complex at downtown’s Arts Complex",
    "capacity": 900,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2750,
    "priceHigh": 22000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42205",
    "name": "Semiprecious",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2839 W. 44th Ave.",
    "capacity": 65,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35356",
    "name": "Senor Bear",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "3301 Tejon St.",
    "capacity": 80,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39645",
    "name": "Sentral Union Station",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1777 Wewatta St.",
    "capacity": 75,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 8500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9421",
    "name": "Singleton Theatre",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis in the Helen Bonfils Theatre Complex at downtown’s Arts Complex",
    "capacity": 200,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2000,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37042",
    "name": "Social Capitol",
    "category": "Restaurant & Private Dining",
    "area": "West Metro / Golden",
    "address": "6543 Wadsworth Blvd.",
    "capacity": 800,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39914",
    "name": "Somebody People",
    "category": "Restaurant & Private Dining",
    "area": "South Broadway / Wash Park",
    "address": "1165 S. Broadway",
    "capacity": 65,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37160",
    "name": "Sonoma'z Wine Bar & Grill",
    "category": "Restaurant & Private Dining",
    "area": "South Metro",
    "address": "10345 Park Meadows Dr.",
    "capacity": 80,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9114",
    "name": "South Metro Denver Chamber",
    "category": "Campus & Meeting Space",
    "area": "South Metro",
    "address": "6972 S. Vine St.",
    "capacity": 115,
    "outdoor": false,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 750,
    "priceHigh": 7500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-14115",
    "name": "Spangalang Brewery",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "2736 Welton St.",
    "capacity": 115,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-29342",
    "name": "Spectra Art Space",
    "category": "Museum & Cultural",
    "area": "South Broadway / Wash Park",
    "address": "1836 S. Broadway",
    "capacity": 125,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1250,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-33739",
    "name": "Sports Castle",
    "category": "Dedicated Event Space",
    "area": "Golden Triangle",
    "address": "1000 Broadway",
    "capacity": 1500,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 3500,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19260",
    "name": "Stanley Marketplace",
    "category": "Dedicated Event Space",
    "area": "East Metro",
    "address": "2501 Dallas St.",
    "capacity": 2000,
    "outdoor": true,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 3500,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36627",
    "name": "State 38 Distilling",
    "category": "Dedicated Event Space",
    "area": "West Metro / Golden",
    "address": "400 Corporate Cir.",
    "capacity": 50,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 8500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39624",
    "name": "Stellar Jay",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "240 14th St.",
    "capacity": 100,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25011",
    "name": "Stem Ciders",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "3040 Blake St.",
    "capacity": 120,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35284",
    "name": "Stir Cooking School",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "1801 Wynkoop",
    "capacity": 80,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41679",
    "name": "Stir Cooking School Highlands",
    "category": "Activity & Team Building",
    "area": "Highlands / LoHi",
    "address": "3215 Zuni St.",
    "capacity": 30,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24315",
    "name": "STK Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1550 Market St.",
    "capacity": 80,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9976",
    "name": "Stoney's Bar and Grill",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "1111 Lincoln St.",
    "capacity": 1200,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19839",
    "name": "Stout Street Social",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1400 Stout St.",
    "capacity": 300,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28470",
    "name": "Stranahan's Colorado Whiskey",
    "category": "Dedicated Event Space",
    "area": "Santa Fe Arts District",
    "address": "200 S. Kalamath St.",
    "capacity": 450,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10023",
    "name": "Studio Loft in the Ellie Caulkins Opera House",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "908 14th St.",
    "capacity": 400,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1750,
    "priceHigh": 14500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19709",
    "name": "Summit",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1902 Blake St.",
    "capacity": 900,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 3750,
    "priceHigh": 33500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39780",
    "name": "Sushi by Scratch Restaurants: Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1441 Larimer St.",
    "capacity": 10,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41782",
    "name": "Symmetry360 Massage",
    "category": "Wellness & Retreat",
    "area": "Highlands / LoHi",
    "address": "2416 W. 32nd Ave.",
    "capacity": 18,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 45,
    "priceHigh": 180,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36927",
    "name": "Syrup Cap Hill",
    "category": "Restaurant & Private Dining",
    "area": "Capitol Hill / Uptown",
    "address": "410 E. 7th Ave.",
    "capacity": 166,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9105",
    "name": "Tamayo",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1400 Larimer St.",
    "capacity": 150,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-21153",
    "name": "Tavernetta",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1889 16th St.",
    "capacity": 125,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35203",
    "name": "Teachers' Lounge Food + Drink",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1250 Welton St.",
    "capacity": 220,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-12279",
    "name": "Terminal Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1701 Wynkoop St.",
    "capacity": 700,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37777",
    "name": "The Arch",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "3001 Walnut St.",
    "capacity": 1000,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2750,
    "priceHigh": 22000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9687",
    "name": "The Atrium",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis inside the Helen G Bonfils Theatre Complex at downtown’s Arts Complex",
    "capacity": 1000,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2750,
    "priceHigh": 22000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-23919",
    "name": "The Bindery",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "1817 Central St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19735",
    "name": "The Bluebird Theater",
    "category": "Performance & Nightlife",
    "area": "Capitol Hill / Uptown",
    "address": "3317 E. Colfax Ave.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35416",
    "name": "The Brighton",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "3403 Brighton Blvd.",
    "capacity": 3000,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 4250,
    "priceHigh": 33500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9170",
    "name": "The Capital Grille",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1450 Larimer St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9342",
    "name": "The Church Nightclub",
    "category": "Performance & Nightlife",
    "area": "Golden Triangle",
    "address": "1160 N. Lincoln St.",
    "capacity": 1972,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 4500,
    "priceHigh": 40500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9491",
    "name": "The Corner Office Restaurant + Martini Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1401 Curtis St.",
    "capacity": 300,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40474",
    "name": "The Devil's Drink",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "1553 Platte St.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9417",
    "name": "The Dorota & Kevin Kilstrom Theatre",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis in the Helen Bonfils Theatre Complex at downtown's Arts Complex",
    "capacity": 380,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2500,
    "priceHigh": 21500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28452",
    "name": "The Empourium Brewing Company",
    "category": "Brewery, Winery & Distillery",
    "area": "Highlands / LoHi",
    "address": "4385 W. 42nd Ave.",
    "capacity": 130,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9066",
    "name": "The Fillmore Auditorium",
    "category": "Performance & Nightlife",
    "area": "Capitol Hill / Uptown",
    "address": "1510 Clarkson St.",
    "capacity": 3000,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 5500,
    "priceHigh": 50500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9617",
    "name": "The Flyfisher LLC",
    "category": "Parks & Outdoor",
    "area": "Denver Metro",
    "address": "831 E. 24th Ave.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 500,
    "priceHigh": 8000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8882",
    "name": "The Fort Restaurant",
    "category": "Restaurant & Private Dining",
    "area": "West Metro / Golden",
    "address": "19192 Hwy. 8",
    "capacity": 600,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-42654",
    "name": "The Gallery and Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "3246 Larimer St.",
    "capacity": 160,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19727",
    "name": "The Gothic Theatre",
    "category": "Performance & Nightlife",
    "area": "South Broadway / Wash Park",
    "address": "3263 S. Broadway",
    "capacity": 600,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 3000,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-35184",
    "name": "The Greenwich",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "3258 Larimer St.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40251",
    "name": "The Hampton Social",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "2501 16th St.",
    "capacity": 370,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9418",
    "name": "The Jones Theatre",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis in the Helen Bonfils Theatre Complex at downtown’s Arts Complex",
    "capacity": 200,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 2000,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9987",
    "name": "The Kitchen American Bistro",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1560 Wazee St.",
    "capacity": 400,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40708",
    "name": "The Legacy",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "4800 National Western Dr.",
    "capacity": 3074,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 4250,
    "priceHigh": 33500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10151",
    "name": "The Lobby",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2191 Arapahoe St.",
    "capacity": 350,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9068",
    "name": "The Lockwood Kitchen & Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1450 Glenarm Pl.",
    "capacity": 400,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-14119",
    "name": "The Nickel",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1100 14th St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-19731",
    "name": "The Ogden Theatre",
    "category": "Performance & Nightlife",
    "area": "Capitol Hill / Uptown",
    "address": "935 E. Colfax Ave.",
    "capacity": 1000,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 3750,
    "priceHigh": 33500,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41823",
    "name": "The Peach Crease Club",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "4180 Wynkoop St.",
    "capacity": 117,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40304",
    "name": "The Spot Climbing Gym",
    "category": "Activity & Team Building",
    "area": "Golden Triangle",
    "address": "1235 Delaware St.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 25,
    "priceHigh": 110,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9700",
    "name": "The Spotted Donkey – Southwestern Grille",
    "category": "Restaurant & Private Dining",
    "area": "North Metro / Boulder",
    "address": "10600 Westminster Blvd.",
    "capacity": 125,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36898",
    "name": "The Tears McFarlane House",
    "category": "Dedicated Event Space",
    "area": "Capitol Hill / Uptown",
    "address": "1290 N. Williams St.",
    "capacity": 100,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1250,
    "priceHigh": 10000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41812",
    "name": "The Urban Farm",
    "category": "Parks & Outdoor",
    "area": "East Metro",
    "address": "10200 Smith Rd.",
    "capacity": 1000,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 15000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-38374",
    "name": "The Velvet Cellar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1500 Wynkoop St.",
    "capacity": 115,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41810",
    "name": "Thornton Arts & Culture Division",
    "category": "Restaurant & Private Dining",
    "area": "North Metro / Boulder",
    "address": "9209 Dorothy Blvd.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-34011",
    "name": "Tom's Watch Bar — Coors Field",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1601 19th St.",
    "capacity": 1000,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36975",
    "name": "Topgolf Swing Suite",
    "category": "Activity & Team Building",
    "area": "Downtown / LoDo / RiNo",
    "address": "1550 Court Pl.",
    "capacity": 62,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28127",
    "name": "Topgolf Thornton",
    "category": "Activity & Team Building",
    "area": "North Metro / Boulder",
    "address": "16011 Grant St.",
    "capacity": 140,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 40,
    "priceHigh": 150,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-31634",
    "name": "Toro Latin Kitchen & Lounge",
    "category": "Restaurant & Private Dining",
    "area": "Cherry Creek",
    "address": "150 Clayton Ln.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37710",
    "name": "Traveling Mercies",
    "category": "Restaurant & Private Dining",
    "area": "East Metro",
    "address": "2501 Dallas St.",
    "capacity": 45,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41598",
    "name": "Truss House at the ArtPark at Arkins",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "3400 Arkins Court",
    "capacity": 416,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-28417",
    "name": "Tupelo Honey",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1650 Wewatta St.",
    "capacity": 250,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-39789",
    "name": "Ukiyo",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1317 14th St.",
    "capacity": 12,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24524",
    "name": "Ultreia Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1701 Wynkoop St.",
    "capacity": 106,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25702",
    "name": "Union Hall",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1750 Wewatta St.",
    "capacity": 100,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-33679",
    "name": "Upper Larimer Event Center",
    "category": "Dedicated Event Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "3034 Larimer St.",
    "capacity": 560,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-22521",
    "name": "Urban Farmer Denver",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1659 Wazee St.",
    "capacity": 300,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9332",
    "name": "Venice Ristorante & Wine Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1700 Wynkoop St.",
    "capacity": 120,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36617",
    "name": "Venture X Denver LoDo",
    "category": "Campus & Meeting Space",
    "area": "Downtown / LoDo / RiNo",
    "address": "1800 Wazee St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 750,
    "priceHigh": 9000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36924",
    "name": "Vibe Coffee & Wine LLC",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1490 Curtis St.",
    "capacity": 180,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-10029",
    "name": "ViewHouse Eatery, Bar & Rooftop",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2015 Market St.",
    "capacity": 500,
    "outdoor": true,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-36754",
    "name": "Vital Root",
    "category": "Restaurant & Private Dining",
    "area": "Highlands / LoHi",
    "address": "3915 Tennyson St.",
    "capacity": 200,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9181",
    "name": "Walker Fine Art",
    "category": "Dedicated Event Space",
    "area": "Golden Triangle",
    "address": "300 W. 11th Ave.",
    "capacity": 150,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1500,
    "priceHigh": 12000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9678",
    "name": "Washington Park Boathouse",
    "category": "Parks & Outdoor",
    "area": "South Broadway / Wash Park",
    "address": "701 S. Franklin Street",
    "capacity": 150,
    "outdoor": true,
    "catering": "Outside caterers allowed",
    "includesFood": false,
    "priceLow": 500,
    "priceHigh": 8000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-34200",
    "name": "Water Grill",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1691 Market St.",
    "capacity": 350,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9420",
    "name": "Weeks Conservatory Theatre",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "1101 13th St. in the Newman Center for Theatre Education",
    "capacity": 185,
    "outdoor": false,
    "catering": "In-house or approved caterers",
    "includesFood": false,
    "priceLow": 2000,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-29137",
    "name": "West Saloon & Kitchen",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "501 16th St.",
    "capacity": 220,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-41090",
    "name": "Western Art Gallery",
    "category": "Museum & Cultural",
    "area": "West Metro / Golden",
    "address": "16500 S. Golden Rd.",
    "capacity": 50,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 1000,
    "priceHigh": 10000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9209",
    "name": "Wings Over the Rockies Air & Space Museum",
    "category": "Museum & Cultural",
    "area": "East Metro",
    "address": "7711 E. Academy Blvd.",
    "capacity": 3500,
    "outdoor": true,
    "catering": "Preferred caterers",
    "includesFood": false,
    "priceLow": 4250,
    "priceHigh": 39000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-24445",
    "name": "Wings Over the Rockies Exploration of Flight",
    "category": "Dedicated Event Space",
    "area": "South Metro",
    "address": "13005 Wings Way",
    "capacity": 700,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": false,
    "priceLow": 2250,
    "priceHigh": 18000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-9419",
    "name": "Wolf Theatre",
    "category": "Performance & Nightlife",
    "area": "Downtown / LoDo / RiNo",
    "address": "14th & Curtis in the Helen Bonfils Theatre Complex at downtown’s Arts Complex",
    "capacity": 610,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": false,
    "priceLow": 3000,
    "priceHigh": 27000,
    "priceBasis": "per_event",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark adjusted for listed capacity",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-38468",
    "name": "Wonderyard Garden + Table",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "2200 Larimer St.",
    "capacity": 300,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-27783",
    "name": "Woodie Fisher Kitchen & Bar",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1999 Chestnut Pl.",
    "capacity": 120,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-25360",
    "name": "Woods Boss Brewing Company",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "2210 California St.",
    "capacity": 180,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-8782",
    "name": "Wynkoop Brewing Company",
    "category": "Brewery, Winery & Distillery",
    "area": "Downtown / LoDo / RiNo",
    "address": "1634 18th St.",
    "capacity": 1000,
    "outdoor": false,
    "catering": "In-house",
    "includesFood": true,
    "priceLow": 30,
    "priceHigh": 95,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-40855",
    "name": "XSO",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "500 16th St.",
    "capacity": 850,
    "outdoor": true,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 75,
    "priceHigh": 190,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  },
  {
    "id": "venue-37993",
    "name": "Yard House",
    "category": "Restaurant & Private Dining",
    "area": "Downtown / LoDo / RiNo",
    "address": "1555 Court Pl.",
    "capacity": 585,
    "outdoor": false,
    "catering": "Ask venue",
    "includesFood": true,
    "priceLow": 45,
    "priceHigh": 145,
    "priceBasis": "per_person",
    "priceConfidence": "benchmark",
    "priceLabel": "Teamward estimated range",
    "pricingMethod": "Denver venue-type benchmark per person",
    "reviewedOn": "2026-09-23"
  }
];

export const DENVER_VENUE_CATEGORIES = [
  "No separate venue needed",
  "Activity & Team Building",
  "Brewery, Winery & Distillery",
  "Campus & Meeting Space",
  "Dedicated Event Space",
  "Hotel & Conference",
  "Museum & Cultural",
  "Parks & Outdoor",
  "Performance & Nightlife",
  "Restaurant & Private Dining",
  "Wellness & Retreat"
];

export const DENVER_VENUE_AREAS = [
  "Capitol Hill / Uptown",
  "Cherry Creek",
  "Denver Metro",
  "Downtown / LoDo / RiNo",
  "East Metro",
  "Golden Triangle",
  "Highlands / LoHi",
  "North Metro / Boulder",
  "Santa Fe Arts District",
  "South Broadway / Wash Park",
  "South Metro",
  "West Metro / Golden"
];
